export type CollectionType = {
  type: string;
  collectionName: string;
  id: string;
  createdAt: Date;
  lastUpdatedAt: Date;
  metadata: {
    description?: string;
  };
};

export type CollectionCount = {
  id: string;
  count: number;
};

export enum CollectionFieldType {
  String = 'String',
  URL = 'URL',
  Image = 'Image',
  // While there is backend support of these 3, let's keep them
  // out of the MVP for now just to make things easier.
  // RichText = 'RichText',
  // MultiSelect = 'MultiSelect',
  // a generic number type
  // Numeric = 'Numeric',
}

export type CollectionFieldSchema = {
  id: string;
  slug: string;
  type: CollectionFieldType;
  isPrimaryField: boolean;
  name?: string;
  description?: string;
};

export interface CollectionDefinition {
  id: string;
  collectionName: string;
  type: string;
  createdAt: string;
  lastUpdatedAt: string;
  schema: {
    fields: CollectionFieldSchema[];
    versionId: string;
  };
}

export type CollectionContent = {
  id: string;
  versionId: string;
  records: {
    id: string;
    record: Record<string, unknown>;
  }[];
  schema: {
    fields: CollectionFieldSchema[];
    versionId: string;
  };
};

export enum RecordAction {
  Append = 'AppendRecord',
  Update = 'UpdateRecord',
  BulkCollectionRecordDelete = 'BulkDeleteRecords',
}

export enum SchemaAction {
  AppendSchemaField = 'AppendSchemaField',
  UpdateSchemaField = 'UpdateSchemaField',
  DeleteSchemaField = 'DeleteSchemaField',
}

export enum CollectionOperation {
  UpdateRecords = 'updateRecords',
  UpdateMetadata = 'updateMetadata',
}
